'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size:14px;\n  font-family:"Open Sans Semi Bold", arial;\n  color:', ';\n  margin:0 0 0.3em 0;\n  color: ', ';\n\n  >input[type="text"], >input[type="password"], >input[type="email"], >select{\n    width:100%;\n  }\n'], ['\n  font-size:14px;\n  font-family:"Open Sans Semi Bold", arial;\n  color:', ';\n  margin:0 0 0.3em 0;\n  color: ', ';\n\n  >input[type="text"], >input[type="password"], >input[type="email"], >select{\n    width:100%;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iaReact = require('ia.react.colorlist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = _styledComponents2.default.label(_templateObject, _iaReact.COLORS.grey4, function (props) {
  return props.disabled ? "#aaa" : "";
});

exports.default = Label;